import { createUrl, restGet } from '~/src/dash/api/rest';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

interface ISalespersonOptionsResponse {
  Users: ISelectOption[];
}

export async function fetchSalespersonOptions(
  publisherID: string,
): Promise<ISalespersonOptionsResponse> {
  const reqUrl = createUrl('/ui_options/users', publisherID, 'v1');
  const response = await restGet<ISalespersonOptionsResponse>(reqUrl, {});
  return response.parsedBody as ISalespersonOptionsResponse;
}

// this wrapper allows it to be used in the current format
export const generateSalespersonOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  return fetchSalespersonOptions(session.publisher.ID)
    .then(({ Users }) => {
      if (checkUserInfoMasked(user.user)) {
        return Users.map((user) => ({
          ...user,
          label: `demo_user_${user.id}`,
        }));
      }
      return Users;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};
